import { Region } from '../types';

export const commonTranslations: Record<Region, {
  nav: {
    home: string;
    problem: string;
    services: string;
    about: string;
    caseStudies: string;
    bookCall: string;
    /** Short booking label for the mobile header (falls back to bookCall). */
    bookCallShort?: string;
  };
  footer: {
    description: string;
    services: string;
    legal: string;
    imprint: string;
    privacy: string;
    about: string;
    careers: string;
    copyright: string;
  };
  cta: {
    bookMeeting: string;
    learnMore: string;
    getStarted: string;
    freeConsultation: string;
  };
  /** Shared blocks of the service, booking and case pages. */
  blocks: {
    caseEyebrow: string;
    related: string;
    relatedAria: string;
    and: string;
    moreCases: string;
  };
}> = {
  de: {
    nav: {
      home: 'Home',
      problem: 'Problem',
      services: 'Ressourcen',
      about: 'Über uns',
      caseStudies: 'Case Studies',
      bookCall: 'Strategiegespräch buchen',
      bookCallShort: 'Gespräch buchen',
    },
    footer: {
      description: 'Prometheus arbeitet ausschließlich im B2B-Umfeld mit erklärungsbedürftigen Angeboten, hohen Dealgrößen und langen Sales-Zyklen.',
      services: 'Ressourcen',
      legal: 'Rechtliches',
      imprint: 'Impressum',
      privacy: 'Datenschutz',
      about: 'Über uns',
      careers: 'Karriere',
      copyright: 'Alle Rechte vorbehalten.',
    },
    cta: {
      bookMeeting: 'Termin buchen',
      learnMore: 'Mehr erfahren',
      getStarted: 'Jetzt starten',
      freeConsultation: 'Kostenloses Erstgespräch',
    },
    blocks: {
      caseEyebrow: 'Aus der Praxis',
      related: 'Passt dazu:',
      relatedAria: 'Verwandte Leistungen',
      and: 'und',
      moreCases: 'Weitere Cases',
    },
  },
  ch: {
    nav: {
      home: 'Home',
      problem: 'Problem',
      services: 'Ressourcen',
      about: 'Über uns',
      caseStudies: 'Case Studies',
      bookCall: 'Strategiegespräch buchen',
      bookCallShort: 'Gespräch buchen',
    },
    footer: {
      description: 'Prometheus arbeitet ausschliesslich im B2B-Umfeld mit erklärungsbedürftigen Angeboten, hohen Dealgrössen und langen Sales-Zyklen.',
      services: 'Ressourcen',
      legal: 'Rechtliches',
      imprint: 'Impressum',
      privacy: 'Datenschutz',
      about: 'Über uns',
      careers: 'Karriere',
      copyright: 'Alle Rechte vorbehalten.',
    },
    cta: {
      bookMeeting: 'Termin buchen',
      learnMore: 'Mehr erfahren',
      getStarted: 'Jetzt starten',
      freeConsultation: 'Kostenloses Erstgespräch',
    },
    blocks: {
      caseEyebrow: 'Aus der Praxis',
      related: 'Passt dazu:',
      relatedAria: 'Verwandte Leistungen',
      and: 'und',
      moreCases: 'Weitere Cases',
    },
  },
  en: {
    nav: {
      home: 'Home',
      problem: 'Problem',
      services: 'Resources',
      about: 'About Us',
      caseStudies: 'Case Studies',
      bookCall: 'Book a Strategy Call',
      bookCallShort: 'Book a call',
    },
    footer: {
      description: 'Prometheus works exclusively in B2B environments with complex offerings, high deal sizes, and long sales cycles.',
      services: 'Resources',
      legal: 'Legal',
      imprint: 'Imprint',
      privacy: 'Privacy Policy',
      about: 'About Us',
      careers: 'Careers',
      copyright: 'All rights reserved.',
    },
    cta: {
      bookMeeting: 'Book a Meeting',
      learnMore: 'Learn More',
      getStarted: 'Get Started',
      freeConsultation: 'Free Consultation',
    },
    blocks: {
      caseEyebrow: 'From practice',
      related: 'Related:',
      relatedAria: 'Related services',
      and: 'and',
      moreCases: 'More cases',
    },
  },
};
